/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.989 2.892v10.216a.88.88 0 01-.88.881H2.891a.88.88 0 01-.881-.88V2.891a.88.88 0 01.88-.881h10.217a.88.88 0 01.88.88zM5.534 6.59H3.772v5.637h1.762V6.59zm.158-1.938a1.015 1.015 0 00-1.007-1.022h-.032a1.022 1.022 0 000 2.044 1.014 1.014 0 001.04-.99v-.032zm6.535 4.15c0-1.694-1.078-2.353-2.149-2.353a2.008 2.008 0 00-1.782.909h-.05V6.59H6.591v5.637h1.761V9.23A1.17 1.17 0 019.41 7.968h.067c.56 0 .976.353.976 1.24v3.02h1.761l.014-3.425z"
}));

export default SvgLinkedin;